import { Activity } from '../activity'
import { Item } from '../item'

import { Template } from './template'

export default new Template({
  description: 'Creating scenario',
  id: Template.Id.CreateScenario,
  name: 'Creating scenario',
  steps: [
    {
      withoutItems: {
        description: 'Adding new scenario to list of scenarios',
        name: 'Adding to list',
        type: Activity.Type.ScenarioAddToList,
      },
    },
    {
      withoutItems: {
        description:
          'Setting all the necessary infrastructure for the scenario',
        name: 'Setting up',
        type: Activity.Type.ScenarioSettingUp,
      },
    },
    {
      basedOnItems: items => {
        const type = Activity.Type.ScenarioImporting
        const steps = items
          .filter(item => item.type === Item.Type.Importer)
          .map(item => ({
            description: `Importing ${item.name} data into the new scenario`,
            item,
            name: `Importing ${item.name} data`,
            type,
          }))
        return steps.length
          ? steps
          : [
              // Placeholder
              {
                description: 'Importing data into the new scenario',
                item: undefined,
                name: 'Importing data',
                type,
              },
            ]
      },
    },
    {
      withoutItems: {
        description:
          'Assigning access to the scenario to the user who created it',
        name: 'Adding access',
        type: Activity.Type.ScenarioAssigningUser,
      },
    },
  ],
})
